import { dateFormats, fieldValidationMessages } from 'app/constants';
import format from 'date-fns/format';

export const MASK_CHAR_FOCUSED = '_';
export const MASK_CHAR_UNFOCUSED = ' ';
export const MASK_EMPTY = '____-__-__';

export const isValidDate = (date?: string | Date) => {
  if (!date) {
    return false;
  }

  const timestamp = Date.parse(date.toString());

  return Number.isNaN(timestamp) === false;
};

interface GetErrorMessageOptions {
  isRequired?: boolean;
  isFocused: boolean;
}

export const getInitialMask = (value: Date | null) => {
  if (value && isValidDate(value)) {
    return format(value, dateFormats.DATE_PICKER_UNFOCUSED);
  }
  return '';
};

export const getErrorMessage = (
  maskValue: string,
  options: GetErrorMessageOptions
) => {
  if (options.isRequired && !maskValue) {
    return fieldValidationMessages.REQUIRED;
  }
  if (
    maskValue &&
    (!maskValue.includes(MASK_CHAR_FOCUSED) || !options.isFocused) &&
    !isValidDate(maskValue)
  ) {
    return 'Invalid Date Format';
  }
  return undefined;
};
